import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import * as $ from 'jquery';
import { ActivatedRoute, Router } from '@angular/router';
import { DateObject, Document_Upload_File, ModuleMenu,GM_APP } from 'src/app/models/common';
import { HeadService } from 'src/app/services/common/headservice';
import { Observable, of, tap } from 'rxjs';
import { serviceConstants } from 'src/app/constants/service.constants';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';

@Component({
  selector: 'app-grants-general-information-charitable',
  templateUrl: './grants-general-information-charitable.component.html',
  styleUrls: ['./grants-general-information-charitable.component.scss']
})
export class GrantsGeneralInformationCharitableComponent implements OnInit, IDeactivateComponent {

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  generalInfoForm: UntypedFormGroup;
  staticformFields: any;
  userType: string = "";
  permission: string = "";
  CharityAppID: string;
  menudata: ModuleMenu;
  therapeuticAreas$: Observable<any>;
  therapeuticAreas1: any=[];
  previouslyReceivedFundDD$: Observable<any>;
  ProgramStartDate: Date = new Date();
  ProgramEndDate: Date = new Date();
  minPStartDate = new Date();
  maxPStartDate: Date | undefined;
  minPEndDate : Date
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;
  currencyType: string = '$';
  grantsapp: GM_APP;
  appid:string;
  operations = [
    {
      name: 'Save',
      type: 'submit',
      callback: this.save,
      self: this
    }
  ];
  uploadedFiles: Document_Upload_File[] = [];
  Application_Type_ID: string="";

  constructor(
    private readonly commonService: CommonService,
    private readonly userService: UserService,
    private readonly DatashareSerivce: GrantsDatashareService,
    private readonly router: Router,
    private readonly activatedrouter:ActivatedRoute,
    private header: HeadService,
    private readonly summaryService: GrantsSummaryService,
  ) {
    this.currencyType = this.userService.getGrantCharitableCurrencySymbol();
    this.Application_Type_ID = activatedrouter.snapshot.queryParams['ApplicationType'];
  }

  ngOnInit() {
    this.minPEndDate = new Date();
    this.minPStartDate = new Date();
    this.DatashareSerivce.CharityID.subscribe(x => {
      this.CharityAppID = x;
    });
   // this.grantsapp = this.commonService.getGrantsApp();
    this.appid = this.commonService.appId;
    this.getStaticFiledsData('GCH01');
    this.userType = this.userService.getUserType();
    this.buildCharitableForm();
    // setTimeout(() => { 
    //   this.setFormPermissions();
    //   if (this.permission == "view") {
    //     this.generalInfoForm.disable();
    //   }
    //   else 
    //     {
    //       this.generalInfoForm.enable();
    //     }
    // }, 700);
    
    this.fetchDropDowns();
    this.fetchGeneralInfo();

    this.commonService.getGlobalDirtyInfo().subscribe((res)=>{
      if(res==true){
        this.generalInfoForm.markAsPristine();
         this.extendedForm.IsFormToched=false;
      }
    });
  }

  private fetchDropDowns() {
    this.fetchTherapeuticAreas();
  }

  fetchTherapeuticAreas() {
    this.summaryService.getLookupList("LU-030",this.appid).subscribe({
      next: (summary:any) => {
        this.therapeuticAreas1 =[{ label: "Select", value: null, checked: true }].concat(summary);
      },
      error: err => {
        console.error(err);
      }
    });
    // this.therapeuticAreas$ = this.summaryService.getLookupList("LU-030").pipe(
    //   tap(l => {
    //     l.concat({ label: "Select", value: null, checked: true });
    //   })
    // );  
    
  }

  private fetchGeneralInfo() {
    this.summaryService.getCharityGeneralInfo("api/GMGeneralInfoCharitable/Fetch?RecordID=" + this.CharityAppID)
      .subscribe({
        next: summary => {
          if (summary != null && summary != undefined) {

           
            this.generalInfoForm.patchValue(summary);

            if (summary["PROGRAM_START_DATE"] != null && summary["PROGRAM_START_DATE"] != "") {
            //  this.ProgramStartDate = new Date(this.generalInfoForm.controls["PROGRAM_START_DATE"].value);
        
              this.ProgramStartDate = this.commonService.getdisplayedDate(this.generalInfoForm.controls["PROGRAM_START_DATE"].value);
              setTimeout(() => {
              this.generalInfoForm.controls["PROGRAM_START_DATE"].setValue(this.ProgramStartDate);
            },0);
             if(  this.ProgramStartDate < new Date())
                this.minPStartDate = this.ProgramStartDate;
              
            }
            if (summary["PROGRAM_END_DATE"] != null && summary["PROGRAM_END_DATE"] != "") {
              //this.ProgramEndDate = new Date(this.generalInfoForm.controls["PROGRAM_END_DATE"].value);

                 this.ProgramEndDate = this.commonService.getdisplayedDate(this.generalInfoForm.controls["PROGRAM_END_DATE"].value);
                 setTimeout(() => {
                 this.generalInfoForm.controls["PROGRAM_END_DATE"].setValue(this.ProgramEndDate);
                },0);
              if(this.ProgramEndDate < new Date())
                  this.minPEndDate = this.ProgramEndDate;
                
            }
          
            this.uploadedFiles = summary['UploadedDocuments'] ?? [];

            if (this.extendedForm != undefined && this.extendedForm != null) {
              this.extendedForm.rowid = summary["ID"];
              this.extendedForm.rowid = summary.ID;
              this.extendedForm.getResponse();
            }
            this.currencyType=summary["CURRENCY_SYMBOL"];
            this.permission=summary["PERMISSION"];

            // By using this permission, page state needs to control.
            if (this.permission == "view") {
              this.generalInfoForm.disable();
            }
            this.setFormPermissions();
           
          }
          else{
           this.userService.getGrantCharitableCurrencySymbol().subscribe(x=>{
              this.currencyType=x["Data"]
            });
          }
          this.generalInfoForm.markAsPristine();
        },
        error: err => {
          console.error(err);
        }
      });
  }

  private setFormPermissions() {     
    //this.permission = "";
      //this.permission = this.commonService.getPagePermission("GCH01");
      if (this.permission == "view") {
        if (this.extendedForm != null && this.extendedForm != undefined) {
          this.extendedForm.permission = this.permission;
          this.extendedForm.ScreenMode = this.permission;
        }
      //  this.generalInfoForm.disable();
      }   

    if (this.permission == "view") {
     // this.generalInfoForm.disable();
      this.operations = [];
    }
    else {
      this.operations = [
        {
          name: 'Save',
          type: 'submit',
          callback: this.save,
          self: this
        }
      ];
    }

    if (this.permission == "view" && this.generalInfoForm!=null && this.generalInfoForm!=undefined) {
      this.generalInfoForm.disable();
    }
    else if(this.generalInfoForm!=null && this.generalInfoForm!=undefined)
      {
        this.generalInfoForm.enable();
      }
  }

  private buildCharitableForm() {
    this.generalInfoForm = new UntypedFormGroup({
      ID: new UntypedFormControl(''),
      APPLICATION_ID: new UntypedFormControl(''),
      APPLICATION_CODE: new UntypedFormControl(''),
      APPLICATION_TITLE: new UntypedFormControl(''),
      THERAPEUTIC_AREA_ID: new UntypedFormControl(null),
      ORG_MISSION_STATEMENT: new UntypedFormControl(''),
      ORG_ANNUAL_OPERATING: new UntypedFormControl(''),
      GEO_FOCUS_ORG: new UntypedFormControl(''),
      REQUESTED_PROGRAM: new UntypedFormControl(''),
      BRIEF_DESC_PROGRAM: new UntypedFormControl(''),
      GOALS_OBJ_PROGRAM: new UntypedFormControl(''),
      GEO_FOCUS_REQUEST: new UntypedFormControl(''),
      PROGRAM_START_DATE: new UntypedFormControl(null),
      PROGRAM_START_DATEO: new UntypedFormControl(null),
      PROGRAM_END_DATE: new UntypedFormControl(null),
      PROGRAM_END_DATEO: new UntypedFormControl(null),
      REQUEST_AMOUNT: new UntypedFormControl(null),
      REQUEST_PROPOSAL: new UntypedFormControl(''),
      PROPOSED_BUDGET: new UntypedFormControl(null),
      ANNUAL_BUDGET: new UntypedFormControl(null),
      IS_PRE_REC_FUND: new UntypedFormControl('')
    });
   
    // Default disabled control
    this.generalInfoForm.markAsPristine();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  save() {
    if (this['self'].validateControls()) {

      this['self'].generalInfoForm.markAsPristine();
      let formData = this['self'].generalInfoForm.value;
      formData.APPLICATION_TITLE=formData.APPLICATION_TITLE==null?null:formData.APPLICATION_TITLE==undefined?undefined:formData.APPLICATION_TITLE.trim();
      formData.ORG_MISSION_STATEMENT=formData.ORG_MISSION_STATEMENT==null?null:formData.ORG_MISSION_STATEMENT==undefined?undefined:formData.ORG_MISSION_STATEMENT.trim();
      formData.ORG_ANNUAL_OPERATING=formData.ORG_ANNUAL_OPERATING==null?null:formData.ORG_ANNUAL_OPERATING==undefined?undefined:formData.ORG_ANNUAL_OPERATING.trim();
      formData.GEO_FOCUS_ORG=formData.GEO_FOCUS_ORG==null?null:formData.GEO_FOCUS_ORG==undefined?undefined:formData.GEO_FOCUS_ORG.trim();
      formData.REQUESTED_PROGRAM=formData.REQUESTED_PROGRAM==null?null:formData.REQUESTED_PROGRAM==undefined?undefined:formData.REQUESTED_PROGRAM.trim();
      formData.BRIEF_DESC_PROGRAM=formData.BRIEF_DESC_PROGRAM==null?null:formData.BRIEF_DESC_PROGRAM==undefined?undefined:formData.BRIEF_DESC_PROGRAM.trim();
      formData.GOALS_OBJ_PROGRAM=formData.GOALS_OBJ_PROGRAM==null?null:formData.GOALS_OBJ_PROGRAM==undefined?undefined:formData.GOALS_OBJ_PROGRAM.trim();
      formData.GEO_FOCUS_REQUEST=formData.GEO_FOCUS_REQUEST==null?null:formData.GEO_FOCUS_REQUEST==undefined?undefined:formData.GEO_FOCUS_REQUEST.trim();
      formData.REQUEST_PROPOSAL=formData.REQUEST_PROPOSAL==null?null:formData.REQUEST_PROPOSAL==undefined?undefined:formData.REQUEST_PROPOSAL.trim();
      formData['PROGRAM_START_DATEO'] = this['self'].GetStartDate();
      formData['PROGRAM_END_DATEO'] = this['self'].GetEndDate();
      if(formData['PROGRAM_END_DATE']!=null && formData['PROGRAM_END_DATE']!="" && formData['PROGRAM_END_DATE']!=undefined)
      {}
    else 
    formData['PROGRAM_END_DATE'] =null;
    if(formData['PROGRAM_START_DATE']!=null && formData['PROGRAM_START_DATE']!="" && formData['PROGRAM_START_DATE']!=undefined)
      {}
    else 
    formData['PROGRAM_START_DATE'] = null;
      let uploadData = new FormData();
      if (this['self'].uploadedFiles?.length > 0) {
        for (let i = 0; i < this['self'].uploadedFiles.length; i++) {
          if (this['self'].uploadedFiles[i].Status == "Add") {
            uploadData.append(this['self'].uploadedFiles[i].ID, this['self'].uploadedFiles[i].File);
            this['self'].uploadedFiles[i].File = null;
          }
        }
      }
      if (this['self'].CharityAppID == "" || this['self'].CharityAppID == undefined) {
      formData['Application_Type_ID']=this['self'].Application_Type_ID;
      }
      formData['UploadedDocuments'] = this['self'].uploadedFiles;
      uploadData.append('GM_APP_CHARITABLE', JSON.stringify(formData));

      if (this['self'].CharityAppID == "" || this['self'].CharityAppID == undefined) {
        this['self'].summaryService.SaveCharityGeneralInfo('api/GMGeneralInfoCharitable/Insert', uploadData)
          .subscribe({
            next: result => {
              
              this['self'].generalInfoForm.markAsPristine();
              let tempID = result["TransactionID"]; //Charity ID
              let tempCode = result["TransactionCode"];// Audit Version ID
              let tempAppID = result["Data"];
              this['self'].CharityAppID = tempID;
              this['self'].DatashareSerivce.setGrantApplicationID(tempAppID);
              this['self'].DatashareSerivce.setCharityID(tempID);

              if (result.Status === 0) {
                this['self'].extendedForm.saveControls(tempID, tempAppID, tempCode)
                  .subscribe({
                    next: result1 => {
                      if (result1.Status === 0) {
                        this['self'].commonService.SuccessBanner(result.Message);
                        this['self'].extendedForm.IsFormToched=false;
                        this['self'].refreshPage(tempAppID, tempID);
                        this['self'].fetchGeneralInfo();
                      }
                      else {
                        this['self'].commonService.ValidationBanner(result1.Message);
                        this['self'].refreshPage(tempAppID, tempID);
                        this['self'].fetchGeneralInfo();
                        if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                          this['self'].extendedForm.IsFormToched=false;
                          this['self'].extendedForm.getResponse();
                        }
                      }
                    }
                  });
              }
              else {
                this['self'].commonService.ValidationBanner(result.Message);
              }
            },
            error: err => {
              console.error(err);
            }
          });
      }
      else {
        this['self'].summaryService.SaveCharityGeneralInfo('api/GMGeneralInfoCharitable/Update', uploadData)
          .subscribe({
            next: result => {
              if (result.Status === 0 || result.ErrorCode === "NOCHANGES") {
                this['self'].fetchGeneralInfo();
                let tempAppID = result["Data"];
                this['self'].extendedForm.saveControls(result.TransactionID, tempAppID, result.TransactionCode)
                  .subscribe({
                    next: result1 => {
                      
                      // this['self'].generalInfoForm.markAsPristine();
                      // if (result1.ErrorCode === "NOCONTROLS") {
                      //   if (result.Status === 0)
                      //   this['self'].commonService.SuccessBanner(result.Message);
                         
                      //   else
                      //   this['self'].commonService.ValidationBanner(result.Message);
                      // }
                      // else {
                      //   if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                      //     this['self'].commonService.ValidationBanner(result.Message);
                      //   }
                      //   else {
                      //     this['self'].commonService.SuccessBanner(result.Message);
                      //     if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                      //       this['self'].extendedForm.getResponse();
                      //     }
                      //   }
                      // }
                      if (result1.ErrorCode === "NOCONTROLS") {
                        if (result.ErrorCode === "NOCHANGES")
                        this['self'].commonService.ValidationBanner(result.Message);
                        else
                        {
                          this['self'].generalInfoForm.markAsPristine();
                          this['self'].commonService.SuccessBanner("General Information saved successfully");
                          this['self'].extendedForm.IsFormToched=false;
                          if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                            this['self'].extendedForm.rowid=result.TransactionID;
                            this['self'].extendedForm.getResponse();
                          }
                        }
                      }
                      else {
                        if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                          this['self'].commonService.ValidationBanner(result.Message);
                        }
                        else {
                          this['self'].generalInfoForm.markAsPristine();
                          this['self'].fetchGeneralInfo();
                          this['self'].commonService.SuccessBanner("General Information saved successfully");
                          this['self'].extendedForm.IsFormToched=false;
                          if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                            this['self'].extendedForm.rowid=result.TransactionID;
                            this['self'].extendedForm.getResponse();
                          }
                        }
                      }
                    },
                    error: err => {
                      console.error(err);
                    }
                  });
              }
              else {
                this['self'].commonService.ValidationBanner(result.Message);
              }
            },
            error: err => {
              console.error(err);
            }
          });
      }
    }
  }

  refreshPage(id: string, transactionID:string) {

    this.summaryService.getCharityAppSummary("api/common/getgrantsapp/" + id).subscribe(data => {
      this.commonService.appId = data.ID;
      this.commonService.ScreenID = transactionID;
      this.commonService.setGrantsApp(data);
      this.menudata = new ModuleMenu();
      this.menudata.module = "GRANTSCHARITABLE";
      this.menudata.operation = "Edit";
      this.menudata.appId = id
      this.menudata.screenID=transactionID;
      this.menudata.formstate = "Draft";
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);

      this.router.navigate(['/home/grants/my-applications/application-ext/:' + id + '/genInformcharitable'], {
        skipLocationChange: true, queryParams: { module: "grants",submodule:this.menudata.module , id: transactionID, app_ext: true, screen_type: "my-applications" }
      });

    });
    this.generalInfoForm.markAsPristine();
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.generalInfoForm.value;

    if (this.staticformFields?.APPLICATION_TITLE?.IS_Display && this.staticformFields?.APPLICATION_TITLE?.IS_MANDATORY) {
      if ((formData.APPLICATION_TITLE === null || formData.APPLICATION_TITLE === ""||formData.APPLICATION_TITLE=== undefined)) {
        $("#APPLICATION_TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#APPLICATION_TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.APPLICATION_TITLE?.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.APPLICATION_TITLE!= null && formData.APPLICATION_TITLE!= undefined&&formData.APPLICATION_TITLE.trim()==""){
        $("#APPLICATION_TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#APPLICATION_TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.APPLICATION_TITLE?.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#APPLICATION_TITLE").addClass("ng-untouched ng-valid");
        $("#APPLICATION_TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.THERAPEUTIC_AREA_ID?.IS_Display && this.staticformFields?.THERAPEUTIC_AREA_ID?.IS_MANDATORY) {
      if ( (formData.THERAPEUTIC_AREA_ID === null || formData.THERAPEUTIC_AREA_ID === "")) {
        $("#THERAPEUTIC_AREA_ID").addClass("ng-touched ng-invalid validate-error");
        $("#THERAPEUTIC_AREA_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.THERAPEUTIC_AREA_ID?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#THERAPEUTIC_AREA_ID").addClass("ng-untouched ng-valid");
        $("#THERAPEUTIC_AREA_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ORG_MISSION_STATEMENT?.IS_Display && this.staticformFields?.ORG_MISSION_STATEMENT?.IS_MANDATORY) {
      if ((formData.ORG_MISSION_STATEMENT === null || formData.ORG_MISSION_STATEMENT === ""||formData.ORG_MISSION_STATEMENT=== undefined)) {
        $("#ORG_MISSION_STATEMENT").addClass("ng-touched ng-invalid validate-error");
        $("#ORG_MISSION_STATEMENT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ORG_MISSION_STATEMENT?.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.ORG_MISSION_STATEMENT!= null && formData.ORG_MISSION_STATEMENT!= undefined && formData.ORG_MISSION_STATEMENT.trim()==""){
        $("#ORG_MISSION_STATEMENT").addClass("ng-touched ng-invalid validate-error");
        $("#ORG_MISSION_STATEMENT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ORG_MISSION_STATEMENT?.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#ORG_MISSION_STATEMENT").addClass("ng-untouched ng-valid");
        $("#ORG_MISSION_STATEMENT").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ORG_ANNUAL_OPERATING?.IS_Display && this.staticformFields?.ORG_ANNUAL_OPERATING?.IS_MANDATORY) {
      if ((formData.ORG_ANNUAL_OPERATING === null || formData.ORG_ANNUAL_OPERATING === ""||formData.ORG_ANNUAL_OPERATING===undefined)) {
        $("#ORG_ANNUAL_OPERATING").addClass("ng-touched ng-invalid validate-error");
        $("#ORG_ANNUAL_OPERATING").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ORG_ANNUAL_OPERATING?.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.ORG_ANNUAL_OPERATING!= null && formData.ORG_ANNUAL_OPERATING!=undefined&&formData.ORG_ANNUAL_OPERATING.trim()==""){
        $("#ORG_ANNUAL_OPERATING").addClass("ng-touched ng-invalid validate-error");
        $("#ORG_ANNUAL_OPERATING").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ORG_ANNUAL_OPERATING?.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#ORG_ANNUAL_OPERATING").addClass("ng-untouched ng-valid");
        $("#ORG_ANNUAL_OPERATING").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.GEO_FOCUS_ORG?.IS_Display && this.staticformFields?.GEO_FOCUS_ORG?.IS_MANDATORY) {
      if ((formData.GEO_FOCUS_ORG === null || formData.GEO_FOCUS_ORG === ""||formData.GEO_FOCUS_ORG===undefined)) {
        $("#GEO_FOCUS_ORG").addClass("ng-touched ng-invalid validate-error");
        $("#GEO_FOCUS_ORG").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GEO_FOCUS_ORG?.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.GEO_FOCUS_ORG!= null &&formData.GEO_FOCUS_ORG!= undefined&&formData.GEO_FOCUS_ORG.trim()==""){
        $("#GEO_FOCUS_ORG").addClass("ng-touched ng-invalid validate-error");
        $("#GEO_FOCUS_ORG").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GEO_FOCUS_ORG?.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#GEO_FOCUS_ORG").addClass("ng-untouched ng-valid");
        $("#GEO_FOCUS_ORG").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.REQUESTED_PROGRAM?.IS_Display && this.staticformFields?.REQUESTED_PROGRAM?.IS_MANDATORY) {
      if ((formData.REQUESTED_PROGRAM === null || formData.REQUESTED_PROGRAM === ""||formData.REQUESTED_PROGRAM===undefined)) {
        $("#REQUESTED_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUESTED_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.REQUESTED_PROGRAM!=null &&formData.REQUESTED_PROGRAM!=undefined&&formData.REQUESTED_PROGRAM.trim()==""){
        $("#REQUESTED_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#REQUESTED_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUESTED_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#REQUESTED_PROGRAM").addClass("ng-untouched ng-valid");
        $("#REQUESTED_PROGRAM").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.BRIEF_DESC_PROGRAM?.IS_Display && this.staticformFields?.BRIEF_DESC_PROGRAM?.IS_MANDATORY) {
      if ((formData.BRIEF_DESC_PROGRAM === null || formData.BRIEF_DESC_PROGRAM === ""||formData.BRIEF_DESC_PROGRAM===undefined)) {
        $("#BRIEF_DESC_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#BRIEF_DESC_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.BRIEF_DESC_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.BRIEF_DESC_PROGRAM != null &&formData.BRIEF_DESC_PROGRAM !== undefined&&formData.BRIEF_DESC_PROGRAM.trim()==""){
        $("#BRIEF_DESC_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#BRIEF_DESC_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.BRIEF_DESC_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#BRIEF_DESC_PROGRAM").addClass("ng-untouched ng-valid");
        $("#BRIEF_DESC_PROGRAM").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.GOALS_OBJ_PROGRAM?.IS_Display && this.staticformFields?.GOALS_OBJ_PROGRAM?.IS_MANDATORY) {
      if ((formData.GOALS_OBJ_PROGRAM === null || formData.GOALS_OBJ_PROGRAM === ""||formData.GOALS_OBJ_PROGRAM===undefined)) {
        $("#GOALS_OBJ_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#GOALS_OBJ_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GOALS_OBJ_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.GOALS_OBJ_PROGRAM!= null &&formData.GOALS_OBJ_PROGRAM!= undefined&&formData.GOALS_OBJ_PROGRAM.trim()==""){
        $("#GOALS_OBJ_PROGRAM").addClass("ng-touched ng-invalid validate-error");
        $("#GOALS_OBJ_PROGRAM").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GOALS_OBJ_PROGRAM?.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#GOALS_OBJ_PROGRAM").addClass("ng-untouched ng-valid");
        $("#GOALS_OBJ_PROGRAM").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.GEO_FOCUS_REQUEST?.IS_Display && this.staticformFields?.GEO_FOCUS_REQUEST?.IS_MANDATORY) {
      if ((formData.GEO_FOCUS_REQUEST === null || formData.GEO_FOCUS_REQUEST === ""||formData.GEO_FOCUS_REQUEST===undefined)) {
        $("#GEO_FOCUS_REQUEST").addClass("ng-touched ng-invalid validate-error");
        $("#GEO_FOCUS_REQUEST").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GEO_FOCUS_REQUEST?.LABEL_NAME} <br/>`;
        isValid = false;
      } else if(formData.GEO_FOCUS_REQUEST!= null && formData.GEO_FOCUS_REQUEST!= undefined&&formData.GEO_FOCUS_REQUEST.trim()==""){
        $("#GEO_FOCUS_REQUEST").addClass("ng-touched ng-invalid validate-error");
        $("#GEO_FOCUS_REQUEST").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.GEO_FOCUS_REQUEST?.LABEL_NAME} <br/>`;
        isValid = false;
      }
      else {
        $("#GEO_FOCUS_REQUEST").addClass("ng-untouched ng-valid");
        $("#GEO_FOCUS_REQUEST").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_START_DATE?.IS_Display && this.staticformFields?.PROGRAM_START_DATE?.IS_MANDATORY) {
      if ((formData.PROGRAM_START_DATE === null || formData.PROGRAM_START_DATE === "")) {
        $("#PROGRAM_START_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_START_DATE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PROGRAM_START_DATE?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_START_DATE").addClass("ng-untouched ng-valid");
        $("#PROGRAM_START_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_END_DATE?.IS_Display && this.staticformFields?.PROGRAM_END_DATE?.IS_MANDATORY) {
      if ((formData.PROGRAM_END_DATE === null || formData.PROGRAM_END_DATE === "")) {
        $("#PROGRAM_END_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#PROGRAM_END_DATE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.PROGRAM_END_DATE?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROGRAM_END_DATE").addClass("ng-untouched ng-valid");
        $("#PROGRAM_END_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROGRAM_START_DATE?.IS_Display && this.staticformFields?.PROGRAM_END_DATE?.IS_Display) {
      if (formData.PROGRAM_START_DATE != null && formData.PROGRAM_END_DATE != null) {
        if (new Date(formData.PROGRAM_START_DATE) > new Date(formData.PROGRAM_END_DATE)) {
          message += "Program end date cannot be lesser than program start date. Please update the details <br/>";
        isValid = false;
      }
    }
    }

    if (this.staticformFields?.REQUEST_AMOUNT?.IS_Display && this.staticformFields?.REQUEST_AMOUNT?.IS_MANDATORY) {
      if ((formData.REQUEST_AMOUNT === null || formData.REQUEST_AMOUNT === "")) {
        $("#REQUEST_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#REQUEST_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUEST_AMOUNT?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#REQUEST_AMOUNT").addClass("ng-untouched ng-valid");
        $("#REQUEST_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.CGenInfo_AddlDocReq?.IS_Display) {
      if (this.staticformFields?.CGenInfo_AddlDocReq?.IS_MANDATORY && this.uploadedFiles.length == 0) {
        message += `Please upload ${this.staticformFields?.CGenInfo_AddlDocReq?.LABEL_NAME} <br/>`;
        isValid = false;
      }
    }

    if (this.staticformFields?.REQUEST_PROPOSAL?.IS_Display && this.staticformFields?.REQUEST_PROPOSAL?.IS_MANDATORY) {
      if ((formData.REQUEST_PROPOSAL === null || formData.REQUEST_PROPOSAL === ""||formData.REQUEST_PROPOSAL===undefined)) {
        $("#REQUEST_PROPOSAL").addClass("ng-touched ng-invalid validate-error");
        $("#REQUEST_PROPOSAL").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUEST_PROPOSAL?.LABEL_NAME} <br/>`;
        isValid = false;
      }else if((formData.REQUEST_PROPOSAL!= null &&formData.REQUEST_PROPOSAL!=undefined&&formData.REQUEST_PROPOSAL.trim()=="")){
        $("#REQUEST_PROPOSAL").addClass("ng-touched ng-invalid validate-error");
        $("#REQUEST_PROPOSAL").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.REQUEST_PROPOSAL?.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#REQUEST_PROPOSAL").addClass("ng-untouched ng-valid");
        $("#REQUEST_PROPOSAL").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.PROPOSED_BUDGET?.IS_Display && this.staticformFields?.PROPOSED_BUDGET?.IS_MANDATORY) {
      if ( (formData.PROPOSED_BUDGET === null || formData.PROPOSED_BUDGET === "")) {
        $("#PROPOSED_BUDGET").addClass("ng-touched ng-invalid validate-error");
        $("#PROPOSED_BUDGET").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.PROPOSED_BUDGET?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#PROPOSED_BUDGET").addClass("ng-untouched ng-valid");
        $("#PROPOSED_BUDGET").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ANNUAL_BUDGET?.IS_Display && this.staticformFields?.ANNUAL_BUDGET?.IS_MANDATORY) {
      if ((formData.ANNUAL_BUDGET === null || formData.ANNUAL_BUDGET === "")) {
        $("#ANNUAL_BUDGET").addClass("ng-touched ng-invalid validate-error");
        $("#ANNUAL_BUDGET").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ANNUAL_BUDGET?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#ANNUAL_BUDGET").addClass("ng-untouched ng-valid");
        $("#ANNUAL_BUDGET").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.IS_PRE_REC_FUND?.IS_Display && this.staticformFields?.IS_PRE_REC_FUND?.IS_MANDATORY) {
      if ((formData.IS_PRE_REC_FUND === null || formData.IS_PRE_REC_FUND === "")) {
        $("#IS_PRE_REC_FUND").addClass("ng-touched ng-invalid validate-error");
        $("#IS_PRE_REC_FUND").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.IS_PRE_REC_FUND?.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#IS_PRE_REC_FUND").addClass("ng-untouched ng-valid");
        $("#IS_PRE_REC_FUND").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    return isValid;
  }

  // uploadFiles(event) {
  //   if (this.uploadedFiles == undefined || this.uploadedFiles == null)
  //     this.uploadedFiles = [];

  //   if (event.target.files && event.target.files.length) {
  //     for (let i = 0; i < event.target.files.length; i++) {
  //       let uploadFile = new Document_Upload_File();
  //       uploadFile.ID = this.NewGuid();
  //       uploadFile.DOCUMENT_NAME = event.target.files[i].name;
  //       uploadFile.File = event.target.files[i];
  //       uploadFile.Status = "Add";
  //       this.uploadedFiles.push(uploadFile);
  //     }
  //   }
  // }

  uploadFiles(event): void {
    if (this.uploadedFiles == undefined || this.uploadedFiles == null) {
      this.uploadedFiles = [];
    }
let DupFlag=false;
let DOCUMENT_NAME="";
    let hasUnFormat = false;
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        hasUnFormat = true;
      }
      else {
        let hasValue;

        uploadFile.ID = this.NewGuid();// this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";

        if (this.uploadedFiles?.length > 0) {
          hasValue = this.uploadedFiles?.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        }

        if (hasValue?.length > 0) {
          DupFlag=true;
          if(DOCUMENT_NAME!="")
          DOCUMENT_NAME += ","+ uploadFile.DOCUMENT_NAME;
        else 
        DOCUMENT_NAME=uploadFile.DOCUMENT_NAME;
          
        } else {
          if (this.staticformFields.CGenInfo_AddlDocReq.IS_MULTISELECT){
            this.uploadedFiles.push(uploadFile);
            } else {
              if(this.generalInfoForm.controls["ID"].value != null){
                this.uploadedFiles.forEach((item)=>{
                  item.Status="Delete";
                });
                this.uploadedFiles.push(uploadFile);
              } else{          
                this.uploadedFiles=[];
                this.uploadedFiles.push(uploadFile);
              }             
            }
        }
      }
    }
if(DupFlag)
this.commonService.ValidationBanner("File already exists with " + DOCUMENT_NAME + " Please update the unique file name");
    if (hasUnFormat) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }
  }

  DeleteUpload(file): void {

    let code = file.ID;
    if (file.Status == "Add") {
      this.uploadedFiles = this.uploadedFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x)=>{
        if(x["Status"]==2 && x["Data"]==false)
        {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else{
          file.Status = "Delete";
        }
      });
  

    }
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  DownloadFile(fileID) 
  {
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
     ;
    this.commonService.previewFile(fileID, fileName, "med");
  }

  NewGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode,this.appid)
      .subscribe({
        next: summary => {
          this.staticformFields = summary["Data"];
          // IS_PRE_REC_FUND field dropdown dynamic values
         // this.staticformFields?.IS_PRE_REC_FUND?.GROUP_VALUES_LIST?.push({ label: "Select", value: null, checked: true });
         let vx=[{ label: "Select", value: null, checked: true }].concat(this.staticformFields?.IS_PRE_REC_FUND?.GROUP_VALUES_LIST);
         this.previouslyReceivedFundDD$ = of(vx);
        }
      });
  }

  CompareDates(olddate: any, newDate: any): boolean {
   
    if (olddate != '' && olddate != undefined && olddate != null) {
  
      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }


  startDateSelect(event) {
   // this.minPEndDate = event;
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }

  endDateSelect(event) {
   // this.maxPStartDate = event;
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  GetStartDate(): DateObject {
    let formModel = this.generalInfoForm.getRawValue();
    const lDate = new Date(formModel.PROGRAM_START_DATE);
    // const lDate = formModel.PROGRAM_START_DATE== null?null :  
    if ((this.CompareDates(this.ProgramStartDate, lDate) || this.Full_Start_Date == null || this.Full_Start_Date == undefined) &&
     formModel.PROGRAM_START_DATE != null) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    else {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Full_Start_Date
  }

  GetEndDate(): DateObject {
    const formModel = this.generalInfoForm.value;
    // const lDate = new Date(formModel.PROGRAM_END_DATE);
    const lDate =new Date(formModel.PROGRAM_END_DATE);
    if ((this.CompareDates(this.ProgramEndDate, lDate) || this.Full_End_Date == null || this.Full_End_Date == undefined) && formModel.PROGRAM_END_DATE!=null)
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: false
      }
    else {
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
  return this.Full_End_Date;
  }

  canExit() {
    if (this.generalInfoForm.dirty || this.extendedForm.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}

